<template>
  <div id="zt8305">
    <div id="k1" :class="$store.state.iscn?'':'k1_en'">
      <div>{{$store.state.iscn?'ZT8305  自助支付模块':'Unattended Payment Terminal'}}</div>
      <label>{{$store.state.iscn?'PCI5.0认证，可通过屏幕输入敏感信息':'pci5.0 certificate, sensitive information can be entered through the virtual keyboard'}}</label>
    </div>
    <div id="k2" v-if="false">
      <label v-if="$store.state.iscn">ZT8305是一款高性能支付主控模块，整机通过PCI5.0认证，可通过屏幕安全键盘输入敏感信息，具有安全舒适的用户体验；该模块提供丰富的外部接口，用户可根据自己的需求扩展不同的功能，广泛应用于加油站、汽车充电站、停车场、新零售等自助场景。</label>
      <label v-else style="width:10rem">PCI5.0 certificated high-performance Capacitive touch screenVarious external interfaces Apply to petrol stations, EV Charging, vending, parking, ticking, etc.</label>
    </div>
    <div id="k3">
      <div>{{$store.state.iscn?'搭配灵活  易于扩展':'Flexibility & Scalability'}}</div>
      <label>{{$store.state.iscn?'可扩展读卡器、身份识别模块、指纹识别模块及支付模块':'Expandable ID, Fingerprint, Facial, NFC etc. module'}}</label>
    </div>
    <div id="k4">
      <span v-if="$store.state.iscn">
        <div>扩展力强  功能丰富</div>
        <label>支持1个SIM、3个PSAM,</label>
        <label>底部支持1个USB、1个Micro USB、4个RS232</label>
        <label>1个RJ45、1个电源、1个4G ANT</label>
      </span>
      <span v-else>
        <h5>Strong Expansibility And Rich Functions</h5>
        <h5>Rich external interfaces, 1 USB host, </h5>
        <h5>1 cash drawer interface, etc.</h5>
      </span>
    </div>
    <div id="k5">
      <div>{{$store.state.iscn?'坚固可靠  经久耐用':'Robust & Durable'}}</div>
      <label>{{$store.state.iscn?'高强度铝合金+防爆触摸屏设计，防尘、防水、防破坏，耐高温、耐潮湿、耐腐蚀':'Explosion-proof touch screen, dust-proof, water-proof, vandal-proof'}}</label>
    </div>
    <payscene :data="sdata"></payscene>
    <pdpp :data="ppdata"></pdpp>
    <pdspecs :data="$store.state.iscn?spdata:spdata_en"></pdspecs>
  </div>
</template>

<script>
import payscene from '@/components/payscene'
import pdpp from '@/components/pdpp'
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    payscene,pdpp,pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      sdata: {
        data: [
          {
            pic: require('@/assets/pic/zt8305/s1.png'),
            label: _this.$store.state.iscn?'人脸支付':'Facial'
          },
          {
            pic: require('@/assets/pic/zt8305/s2.png'),
            label: _this.$store.state.iscn?'加油卡支付':'Card'
          },
        ]
      },
      ppdata: {
        title: 'Performance and Optional parts',
        desc: _this.$store.state.iscn?'非接IC读卡器、指纹、磁条IC二合一读卡器、摄像头、扫码':'Contact/Magnetic、Contactless、Fingerprint、Facial、Scanner',
        data: [
          {
            pic: require('@/assets/pic/zt8305/p1.png'),
            label: _this.$store.state.iscn?'非接IC读卡器':'Contactless'
          },
          {
            pic: require('@/assets/pic/zt8305/p2.png'),
            label: _this.$store.state.iscn?'指纹':'Fingerprint'
          },
          {
            pic: require('@/assets/pic/zt8305/p3.png'),
            label: _this.$store.state.iscn?'磁条IC二合一读卡器':'Contact/Magnetic '
          },
          {
            pic: require('@/assets/pic/zt8305/p4.png'),
            label: _this.$store.state.iscn?'摄像头':'Camera'
          },
          {
            pic: require('@/assets/pic/zt8305/p5.png'),
            label: _this.$store.state.iscn?'扫码':'Scanner'
          },
        ]
      },
      spdata: {
        file: 'ZT8305',
        data: [ 
          {label: '处理器', desc: ['ARM四核1.1GHz高速处理器','32位高性能安全处理器'],pic: 'cpu.png'},
          {label: '存储器', desc: ['1GB RAM+8GB ROM','2GB RAM+16GB ROM（可选）','支持MicrosSD扩展，最大32GB'],pic: 'ram.png'},
          {label: '操作系统', desc: ['Android 5.1','证通安全操作系统（ZOS）'], pic: 'sys.png'},
          {label: '安全', desc: ['支持3DES、AES、RSA、SHA-256、SM2、SM3、SM4等算法'], pic: 'safe.png'},
          {label: '显示屏', desc: ['5.7英寸640×480 高亮液晶屏','防爆电容触摸屏'], pic: 'disp.png'},
          {label: '读卡器（选配)', desc: ['磁条IC二合一读卡器×1','非接读卡器×1','PSAM读卡器×2'], pic: 'read.png'},
          {label: '移动网络', desc: ['支持 GSM / WCDMA / EVDO / TD-SCDMA /  TDD-LTE / FDD-LTE'], pic: 'mobi.png'},
          {label: 'WIFI', desc: ['支持IEEE 802.11 b /g/ n,2.4GHz'], pic: 'wifi.png'},
          {label: '蓝牙', desc: ['支持蓝牙 4.0及以上','支持BLE'], pic: 'blt.png'},
          {label: '定位', desc: ['内置GPS / 北斗 / Glonass','支持LBS功能','支持AGPS'], pic: 'lbs.png'},
          {label: '音频', desc: ['标准3.5 mm'], pic: 'vf.png'},
          {label: '防护等级', desc: ['IP65防尘防水'], pic: 'guard.png'},
          {label: '电源输入', desc: ['DC12V/5A'], pic: 'char.png'},
          {label: '接口', desc: ['USB×1、 Micro USB×1、RS232×4、RJ45×1、电源×1、4G ANT×1、WiFi ANT×1'], pic: 'port.png'},
          {label: '尺寸（长×宽×高）', desc: ['162mm×141mm×37.7mm'], pic: 'size.png'},
          {label: '适用环境', desc: ['工作温度：-20℃～+70℃','存储温度：-40℃～+85℃','相对湿度：10%～90% RH (不结露)'], pic: 'env.png'}
        ]
      },
      spdata_en: {
        file: 'ZT8305',
        data: [ 
          {label: 'Processor', desc: ['Quad-oore@ 1.1GHz', '32-bitsea rityprooessor'],pic: 'cpu.png'},
          {label: 'Memory', desc: ['1GB RAM+8GB ROM', '2GB RAM+ 16GB ROM (optional)', 'Micros SD x1, suppot up to 32GB'],pic: 'ram.png'},
          {label: 'OS', desc: ['ZOS Based on Android 5.1/7.1'], pic: 'sys.png'},
          {label: 'Algorithm', desc: ['3DES, AES, RSA, SHA-256.', 'SM2, SM3, SM4, etc.'], pic: 'safe.png'},
          {label: 'Display', desc: ['5.7" 640x480','Explosion- proof capacitive touch screen'], pic: 'disp.png'},
          {label: 'Card Reader (optional)', desc: ['Magnetic stripe x1、contact IC x1','Contactless IC x1、PSAM x2'], pic: 'read.png'},
          {label: 'Cellular Network', desc: ['GSM/ WCDMA/ EVDO/TD-SCDMA/ TDD-LTE/FDD-LTE'], pic: 'mobi.png'},
          {label: 'WIFI', desc: ['IEEE 802.11 b/g/n', '2.4GHz'], pic: 'wifi.png'},
          {label: 'Bluetooth', desc: ['Bluetooth 4.0 and above','BLE'], pic: 'blt.png'},
          {label: 'Location', desc: ['Built-in GPS/Beidou/Glonass','LBS', 'AGPS'], pic: 'lbs.png'},
          {label: 'Audio', desc: ['Digital microphones and speakers interface(3.5mm )'], pic: 'vf.png'},
          {label: 'Sealing', desc: ['IP65'], pic: 'guard.png'},
          {label: 'Input', desc: ['DC12V/5A'], pic: 'char.png'},
          {label: 'Port', desc: ['USBx1、Micro USBx 1、RS232x4', 'RJ45x1、Powerx1、4G ANTx 1', 'WiFiANTx 1'], pic: 'port.png'},
          {label: 'Dimension(LxWxH)', desc: ['162mmx 141mm x 37.7mm'], pic: 'size.png'},
          {label: 'Environment', desc: ['Working temp: -20°C ~+70°C','Storage temp: -40C~+85C','Relative humidity: 10%~90%RH (non-condensing)'], pic: 'env.png'}
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt8305 {
  background: white;
  margin-top: -.93rem;
}
#k1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8305/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.57rem;
  color: #FFFFFF;
}
.k1_en {
  background-image: url('../../assets/pic/zt8305/bg1_en.jpg') !important;
}
#k1 div {
  margin-top: 3.1rem;
  font-size: .6rem;
  font-weight: bold;
  width: 6.2rem;
}
#k1 label {
  display: block;
  font-size: .36rem;
  font-weight: 400;
  margin-top: .2rem;
  width: 7.6rem;
}
#k1 img {
  width: 4.9rem;
}
#k2 {
  height: 1.75rem;
  background: #1E1E1E;
  text-align: center;
  overflow: hidden;
}
#k2 label {
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  display: block;
  width: 15.91rem;
  margin: .45rem auto;
  line-height: .48rem;
}
#k3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8305/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 9.22rem;
}
#k3 div {
  margin: 3.58rem 0 .13rem 0;
  font-size: .6rem;
  font-weight: bold;
  color: #FFFFFF;
}
#k3 label {
  font-size: .24rem;
  font-weight: 400;
  color: #FEFEFF;
  display: block;
  width: 3.78rem;
}

#k4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8305/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.68rem;
}
#k4 div {
  margin-top: 2.79rem;
  margin-bottom: .14rem;
  font-size: .6rem;
  font-weight: bold;
  color: #333333;
}
#k4 label {
  font-size: .3rem;
  font-weight: 400;
  display: block;
  color: #4D4D4D;
}
#k4 h5:nth-child(1) {
  font-size: .6rem;
  font-weight: bold;
  color: #404040;
  width: 6.04rem;
  margin: 2rem 0 .2rem 0;
}
#k4 h5:nth-child(2), #k4 h5:nth-child(3) {
  font-size: .36rem;
  font-weight: 500;
  color: #4D4D4D;
  /* width: 4.2rem; */
  margin: 0;
}

#k5 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8305/bg4.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.46rem;
}
#k5 div {
  color: white;
  font-weight: bold;
  font-size: .6rem;
  margin-top: 2.47rem;
  margin-bottom: .26rem;
}
#k5 label {
  font-size: .24rem;
  font-weight: 400;
  color: #FEFEFF;
  display: block;
  width: 4.9rem;
}

</style>
